import { Heading, magma } from 'react-magma-dom';
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  Heading,
  magma,
  LeadParagraph,
  React
};